module.exports = __webpack_public_path__ + "img/cw.055674d6.svg";